import "./footer.css";
import logo from "../assets/logo.png";

function Footer() {
return (
    <div className="row">
    <div className="footer">
        <div className="lists">
        <div className="listleft">
            <p>instagram.com/test</p>
            <p>partenaire.fr/test</p>
            <p>wc.com/cgu</p>
            <p>wc.com/cdu</p>
        </div>
        <div className="listright">
            <p>test</p>
            <p>test</p>
            <p>test</p>
            <p>test</p>
        </div>
        </div>
    </div>
    </div>
);
}

export default Footer;